export default __webpack_public_path__ + "static/media/person-3.e5db4ee4.jpg";